/* MM v17 (22-10-2026) · Botón «Añadir» del bloque «Completa tu…» del cajón del carrito (snippets/mm-cajon-completa).
   Va aquí y no en el snippet porque el cajón se repinta por Section Rendering y los <script> repintados no se ejecutan.
   Script clásico (no módulo) para no adelantarse al importmap de snippets/scripts.liquid; el import es dinámico, al pulsar. */
if (!window.mmcjInit) {
    window.mmcjInit = true;
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest && e.target.closest('[data-mmcj-add]');
      if (!btn) return;
      e.preventDefault();
      const { CartLinesUpdateEvent } = await import('@shopify/events');
      btn.disabled = true; btn.textContent = 'Añadiendo…';
      const id = btn.getAttribute('data-mmcj-add');
      const secciones = [...document.querySelectorAll('cart-items-component')].map((x) => x.dataset.sectionId).filter(Boolean).join(',');
      const diferido = CartLinesUpdateEvent.createPromise();
      btn.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(id), quantity: 1 }], promise: diferido.promise }));
      try {
        const r = await fetch(Theme.routes.cart_add_url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: secciones }) }).then((x) => x.json());
        const carrito = await fetch(Theme.routes.cart_url + '.json', { headers: { Accept: 'application/json' } }).then((x) => x.json());
        diferido.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(carrito), detail: { items: carrito.items, source: 'mm-cajon-completa', itemCount: 1, sections: r.sections, didError: !!r.status } });
      } catch (err) {
        diferido.reject(err); btn.disabled = false; btn.textContent = 'Añadir';
      }
    });
  }

/* MM v18 (22-10-2026) · Kit completo (snippets/mm-kit) y fecha estimada de entrega (snippets/mm-plazo). */
(function () {
  if (window.mmKitInit) return;
  window.mmKitInit = true;
  var eur = function (c) { var p = (Math.round(c) / 100).toFixed(2).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1] + ' €'; };

  async function anadir(items, btn, textoOk) {
    const { CartLinesUpdateEvent } = await import('@shopify/events');
    const secciones = [...document.querySelectorAll('cart-items-component')].map((x) => x.dataset.sectionId).filter(Boolean).join(',');
    const diferido = CartLinesUpdateEvent.createPromise();
    btn.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })), promise: diferido.promise }));
    try {
      const r = await fetch(Theme.routes.cart_add_url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items, sections: secciones }) }).then((x) => x.json());
      const carrito = await fetch(Theme.routes.cart_url + '.json', { headers: { Accept: 'application/json' } }).then((x) => x.json());
      diferido.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(carrito), detail: { items: carrito.items, source: 'mm-kit', itemCount: items.length, sections: r.sections, didError: !!r.status } });
      btn.textContent = r.status ? 'No se pudo añadir. Inténtalo de nuevo' : textoOk;
    } catch (err) { diferido.reject(err); btn.textContent = 'No se pudo añadir. Inténtalo de nuevo'; }
    setTimeout(function () { btn.disabled = false; btn.textContent = 'Añadir el kit al carrito'; }, 2500);
  }

  function kit() {
    var k = document.getElementById('mm-kit');
    if (!k) return;
    var totalEl = k.querySelector('[data-mmkit-total]');
    var recalcula = function () {
      var t = Number(k.dataset.base) || 0;
      k.querySelectorAll('[data-mmkit-item]').forEach(function (c) { if (c.checked) t += Number(c.dataset.precio) || 0; });
      totalEl.textContent = eur(t);
      return t;
    };
    k.addEventListener('change', recalcula);
    k.querySelector('[data-mmkit-add]').addEventListener('click', function (e) {
      var btn = e.currentTarget;
      var formId = document.querySelector('main form[action*="/cart/add"] input[name="id"]');
      var items = [{ id: Number((formId && formId.value) || k.dataset.baseId), quantity: 1 }];
      k.querySelectorAll('[data-mmkit-item]').forEach(function (c) { if (c.checked) items.push({ id: Number(c.dataset.mmkitItem), quantity: 1 }); });
      btn.disabled = true; btn.textContent = 'Añadiendo…';
      anadir(items, btn, 'Kit añadido');
    });
    var form = document.querySelector('main product-form-component');
    if (form && !document.querySelector('.mm-kit-link')) {
      var a = document.createElement('a');
      a.href = '#mm-kit'; a.className = 'mm-kit-link';
      a.textContent = 'o llévate el kit completo por ' + eur(recalcula()) + ' →';
      form.insertAdjacentElement('afterend', a);
    }
  }

  function entrega() {
    var pz = window.MM_PLAZO;
    var h1 = document.querySelector('main h1');
    /* 25-10: el párrafo ya viene pintado del servidor (snippets/mm-entrega); aquí solo se corrige el texto si la página viene de caché de otro día. */
    var ya = document.querySelector('.mm-entrega');
    if (!pz || !h1) return;
    var festivos = ['2026-12-08', '2026-12-25', '2027-01-01', '2027-01-06', '2027-03-26', '2027-05-01'];
    var iso = function (d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); };
    var habil = function (d) { var w = d.getDay(); return w !== 0 && w !== 6 && festivos.indexOf(iso(d)) === -1; };
    var ahora = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Madrid' }));
    var base = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate());
    var inicio = new Date(base);
    if (!habil(inicio) || ahora.getHours() >= 13) { do { inicio.setDate(inicio.getDate() + 1); } while (!habil(inicio)); }
    var suma = function (n) { var d = new Date(inicio), c = n; while (c > 0) { d.setDate(d.getDate() + 1); if (habil(d)) c--; } return d; };
    var f = function (d) { return d.toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric', month: 'short' }).replace(',', ''); };
    var html = 'Entrega estimada: <strong>entre el ' + f(suma(pz.min)) + ' y el ' + f(suma(pz.max)) + '</strong> · península';
    if (ya) { if (ya.innerHTML.trim() !== html) ya.innerHTML = html; return; }
    var p = document.createElement('p');
    p.className = 'mm-entrega';
    p.innerHTML = html;
    var grupo = h1.closest('.group-block-content') || h1.parentElement;
    grupo.appendChild(p);
  }

  function init() { kit(); entrega(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* MM v20 22-10: diseño inspirado en tiendas premium (cabecera de colección, etiquetas en ficha, acordeones, accesos rápidos) */
(function () {
  function datos(id) { var e = document.getElementById(id); if (!e) return null; try { return JSON.parse(e.textContent); } catch (x) { return null; } }
  function miles(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function tras(ref, el) { var h = ref.closest('.text-block') || ref; h.parentNode.insertBefore(el, h.nextSibling); }
  function chips(lista, cur, extra) {
    var nav = document.createElement('nav'); nav.className = 'mm-chips' + (extra ? ' ' + extra : ''); nav.setAttribute('aria-label', 'Categorías');
    lista.forEach(function (c) {
      var a = document.createElement('a'); a.href = c.u; a.textContent = c.t.replace(/ para (pájaros|perros|gatos|roedores)$/i, '').replace(/ de seguridad$/i, ''); a.className = 'mm-chip';
      if (cur && c.u === cur) { a.className += ' is-on'; a.setAttribute('aria-current', 'page'); }
      nav.appendChild(a);
    });
    return nav;
  }
  function encaja(nav) {
    var more = nav.querySelector('.mm-chip--more'); if (!more) return;
    var cs = [].slice.call(nav.querySelectorAll('.mm-chip:not(.mm-chip--more)'));
    cs.forEach(function (c) { c.classList.remove('is-hidden'); });
    more.hidden = true;
    if (window.innerWidth < 750) {
      /* v26 29-10: en móvil rejilla de 2 columnas, 5 visibles + «+N más» (antes tira deslizable) */
      nav.classList.remove('has-more');
      var MAX = 5; if (cs.length <= MAX + 1) return;
      more.hidden = false;
      if (nav.classList.contains('is-open')) { more.textContent = 'Ver menos'; more.setAttribute('aria-expanded', 'true'); return; }
      more.setAttribute('aria-expanded', 'false');
      var vis = 0, hidM = 0;
      cs.forEach(function (c, i) { if (i < MAX || c.classList.contains('is-on')) vis++; else { c.classList.add('is-hidden'); hidM++; } });
      if (vis > MAX) { for (var j = MAX - 1; j > 0; j--) { if (!cs[j].classList.contains('is-on')) { cs[j].classList.add('is-hidden'); hidM++; break; } } }
      more.textContent = '+' + hidM + ' más';
      return;
    }
    nav.classList.remove('has-more');
    var top = cs[0].offsetTop;
    if (cs[cs.length - 1].offsetTop === top) return;
    more.hidden = false;
    if (nav.classList.contains('is-open')) { more.textContent = 'Ver menos'; more.setAttribute('aria-expanded', 'true'); return; }
    more.setAttribute('aria-expanded', 'false');
    var hid = 0;
    for (var i = cs.length - 1; i > 0; i--) {
      if (!cs[i].classList.contains('is-on')) { cs[i].classList.add('is-hidden'); hid++; }
      more.textContent = '+' + hid + ' más';
      if (more.offsetTop === top) break;
    }
  }
  function cabecera() {
    var d = datos('mm-colhead'); if (!d || document.querySelector('.mm-colhead')) return;
    var h = document.querySelector('main h1'); if (!h) return;
    var lista = (d.chips || []).slice(), vistas = {};
    lista.forEach(function (c) { vistas[c.u] = 1; });
    var sub = document.querySelector('[id$="__subnav"]');
    if (sub) {
      sub.querySelectorAll('a[href*="/collections/"]').forEach(function (a) {
        var u = a.getAttribute('href').split('?')[0];
        if (!vistas[u]) { vistas[u] = 1; lista.push({ t: a.textContent.trim(), u: u }); }
      });
    }
    var box = document.createElement('div'); box.className = 'mm-colhead';
    var n = document.createElement('p'); n.className = 'mm-colhead__n'; n.textContent = miles(d.n) + (d.n === 1 ? ' producto' : ' productos');
    box.appendChild(n);
    if (lista.length > 1) {
      var nav = chips(lista, d.cur);
      var more = document.createElement('button'); more.type = 'button'; more.className = 'mm-chip mm-chip--more'; more.hidden = true;
      more.addEventListener('click', function () { nav.classList.toggle('is-open'); encaja(nav); });
      nav.appendChild(more); box.appendChild(nav);
      if (sub) sub.style.display = 'none';
      tras(h, box);
      encaja(nav);
      var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { encaja(nav); }, 150); });
      nav.addEventListener('scroll', function () { if (window.innerWidth < 750) nav.classList.toggle('has-more', nav.scrollLeft + nav.clientWidth < nav.scrollWidth - 4); }, { passive: true });
      var on = nav.querySelector('.is-on'); if (on && window.innerWidth < 750) requestAnimationFrame(function () { nav.scrollLeft = Math.max(0, on.offsetLeft - 16); });
      return;
    }
    tras(h, box);
  }
  function etiquetas() {
    var d = datos('mm-pills'); if (!d || document.querySelector('.mm-pills')) return;
    d = d.filter(function (t) { return t && t.trim(); }).slice(0, 3); if (!d.length) return;
    var h = document.querySelector('.product-information h1') || document.querySelector('main h1'); if (!h) return;
    var ul = document.createElement('ul'); ul.className = 'mm-pills';
    d.forEach(function (t) { var li = document.createElement('li'); t = t.trim(); li.textContent = t.length > 32 ? t.slice(0, 30) + '…' : t; ul.appendChild(li); });
    tras(h, ul);
  }
  function acordeones() {
    var d = document.querySelector('.mm-detail__desc'); if (!d || d.dataset.mmAcc) return;
    if (!d.querySelector(':scope > h2')) return;
    d.dataset.mmAcc = '1';
    var hijos = [].slice.call(d.children), actual = null, n = 0;
    hijos.forEach(function (k) {
      if (k.tagName === 'H2') {
        n++; actual = document.createElement('details'); actual.className = 'mm-acc';
        if (n === 1 || /compar/i.test(k.textContent)) actual.open = true;
        var s = document.createElement('summary'); s.appendChild(k); actual.appendChild(s); d.appendChild(actual);
      } else if (actual) { actual.appendChild(k); }
    });
  }
  function accesos() {
    var hero = document.querySelector('.mmh'); if (!hero || document.querySelector('.mm-quick')) return;
    var L = [['Voladeros', '/collections/voladeros-para-pajaros'], ['Perreras', '/collections/perreras-y-boxes-para-perros'], ['Jaulas para loros', '/collections/jaulas-para-loros'], ['GPS Dogtrace', '/collections/dogtrace'], ['Casetas perro', '/collections/casetas-para-perros'], ['Pajareras', '/collections/pajareras-para-pajaros']];
    var nav = chips(L.map(function (x) { return { t: x[0], u: x[1] }; }), null, 'mm-quick');
    var sec = hero.closest('.shopify-section') || hero; sec.parentNode.insertBefore(nav, sec.nextSibling);
  }
  function init() { cabecera(); etiquetas(); acordeones(); accesos(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* MM v21 22-10: «También te puede gustar» sin repetir lo que ya sale en el kit o en «Completa tu compra» */
(function () {
  function limpia(rec) {
    var ya = {};
    document.querySelectorAll('#mm-kit a[href], .mm-cmp a[href], #mm-kit [data-handle]').forEach(function (a) { var h = (a.getAttribute('href') || '').split('?')[0]; if (h) ya[h] = 1; });
    var cards = rec.querySelectorAll('product-card');
    if (!cards.length) return false;
    var vivos = 0;
    cards.forEach(function (c) {
      var a = c.querySelector('a[href*="/products/"]'); var h = a ? a.getAttribute('href').split('?')[0] : '';
      var item = c.closest('.resource-list__item, li') || c;
      if (h && ya[h]) item.style.display = 'none'; else vivos++;
    });
    if (vivos < 2) { var s = rec.closest('.shopify-section'); if (s) s.style.display = 'none'; }
    return true;
  }
  function init() {
    var rec = document.querySelector('product-recommendations'); if (!rec) return;
    if (limpia(rec)) return;
    var mo = new MutationObserver(function () { if (limpia(rec)) mo.disconnect(); });
    mo.observe(rec, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
